<template>
  <div>
    <a-layout id="components-layout-demo-custom-trigger">
      <a-layout-sider
        v-model="collapsed"
        :trigger="null"
        collapsible
      >
        <div
          class="logo"
          v-if="!collapsed"
        >
          <img
            src="~@/assets/img/logo.svg"
            class="logo"
            alt="logo"
          >
        </div>
        <a-menu
          theme="dark"
          mode="inline"
          :default-selected-keys="[indexKey]"
          @click="handleClick"
        >
          <a-menu-item key="1">
            <a-icon type="video-camera" />
            <span>非人物素材</span>
          </a-menu-item>
          <a-menu-item key="2">
            <a-icon type="user" />
            <span>人物素材</span>
          </a-menu-item>
          <!-- <a-menu-item key="3">
          <a-icon type="upload" />
          <span>nav 3</span>
        </a-menu-item> -->
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-header style="background: #fff; padding: 0">
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="() => (collapsed = !collapsed)"
          />
          <Login />
        </a-layout-header>
        <a-layout-content
          :style="{
            margin: '24px 16px',
            padding: '24px',
            background: '#fff',
            minHeight: '280px'
          }">
          <router-view />
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>

import Login from '@/components/Layout/topMenu'
export default {
  components: { Login },
  data () {
    return {
      indexKey: '1',
      collapsed: false
    }
  },

  methods: {
    handleClick ({ key }) {
      switch (key) {
        case '1':
          this.$router.replace('/manage/chartlet')
          break
        case '2':
          this.$router.replace('/manage/person')
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ant-layout.ant-layout-has-sider {
  flex-direction: row;
  min-height: 100vh;
}

#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;

  margin: 16px;
  h1 {
    color: #fff;
    font-size: 20px;
    margin: 0 0 0 12px;
    font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
    font-weight: 600;
    vertical-align: middle;
  }
}
</style>
